import { Typography, useTheme } from "@mui/material";
import { AmountNotice } from "web_myplann/Goals/Components/AmountSections/AmountNotice";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	totalValue: number;
	drawdownMode: RentDrawdownMode;
	rentYears: number;
	currencySuffix: string;
};

export const RentTotalRow: React.FC<Props> = ({
	totalValue,
	drawdownMode,
	rentYears,
	currencySuffix,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const isPerpetual = drawdownMode === RentDrawdownMode.Perpetual;

	return (
		<AmountNotice tone="muted">
			<LabeledValueRow
				label={
					<Typography variant="body1" color={theme.palette.grey[600]}>
						{isPerpetual
							? t(Resources.Goals.Form.Pension.totalLabelPerpetual)
							: t(Resources.Goals.Form.Pension.totalLabelToZero)}
					</Typography>
				}
				value={
					<Typography variant="bodyStrong" tabular>
						{formatNumber(totalValue)} {currencySuffix}
					</Typography>
				}
			/>
			<Typography variant="caption" color={theme.palette.grey[500]}>
				{isPerpetual
					? t(Resources.Goals.Form.Pension.totalDescriptionPerpetual, {
							years: rentYears || "?",
						})
					: t(Resources.Goals.Form.Pension.totalDescriptionToZero, {
							years: rentYears || "?",
						})}
			</Typography>
		</AmountNotice>
	);
};
